import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

// const baseURL = "http://localhost:3044";
const baseURL = "https://atci.abcuniversity.accenture.com/abc-university-apis";

export const UsersSlice = createSlice({
  name: "UserList",
  initialState: {
    usersData: [],
    newUser: "",
  },
  reducers: {
    setError: (state) => {
      state.error = true;
    },
    setUsersData: (state, { payload }) => {
      state.error = false;
      state.usersData = payload;
    },
    setNewUser: (state, { payload }) => {
      state.error = false;
      state.newUser = payload;
    }

  },
});

export const { setError, setUsersData, setNewUser } = UsersSlice.actions;
export default UsersSlice.reducer;

export function getUsers() {
  return (dispatch) => {
    axios
      .get(
        `${baseURL}/getUsers`,
        {
          headers: {
            Authorization: localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        dispatch(setUsersData(res.data.results));
        console.log("res from get api", res.data.results);
        console.log("get users success!!!");
      })
      .catch((err) => {
        dispatch(setError(err));
        console.error("error is", err);
      });
  };
}

export function addUser(username, purpose, market, du) {
  return (dispatch) => {
    axios
      .post(
        `${baseURL}/adduser`,
        { username, purpose, market, du },
        {
          headers: {
            Authorization: localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        dispatch(setNewUser(username));
        console.log("res from post api", res.data);
      })
      .catch((err) => {
        dispatch(setError(err));
        console.error("error is", err);
      });
  };
}